const pap = {transitionSpeed: 'normal', doAnimate: true};
pap.transitionSpeed = 100;
pap.doAnimate = false;

pap.K_internalPageLocalisation = "internal/localisation";
pap.K_internalPageLights = "internal/lights";
pap.K_internalPageEquipments = "internal/equipments";
pap.K_internalPageAudionav = "internal/audionav";
pap.K_internalPageIndexAlpha = "internal/indexalpha";

pap.defaultpage = "localisation/index.html";
pap.initUrlPage = "";
pap.currentPage = "";
pap.hashchangeEnabled = false;
pap.dontPopState = false

pap.init = function () {
  if ( typeof window.addEventListener != 'undefined' ) {
    window.addEventListener("message", pap.ecranEstCharge, false)
  window.addEventListener("popstate", pap.popstateHistory, false)
  } else if ( typeof window.attachEvent != 'undefined' ) {
    window.attachEvent('onmessage', pap.ecranEstCharge)
  window.attachEvent('popstate', pap.popstateHistory)
  }
}

pap.initPage = function() {
  if (psa_params.data.modeXSL === true) {
    pap.defaultpage = pap.K_internalPageLocalisation;
  } else {
    pap.defaultpage = "localisation/index.html";
  }

  var parsedUrlPage = URI(pap.initUrlPage)
  var targetPage = pap.getIdEcranFromURL(parsedUrlPage)

  preferences.setIdVehicule(parsedUrlPage.query(true).idVehicule);

  pap.hashchangeEnabled = true;
  docParams.init();
  historique.init();
  pleinEcran.init();
  footerController.init();

  if (psa_params.data.isDoc === undefined) {
    drawerNavigation.init();
    drawerNavigation.loadListVehicles();
  }

  scrollController.deleteScroll();

  if (psa_params.data.modeEGuide === true) {

  } else {
    if (targetPage === "") {
      targetPage = preferences.getItemVehicle("lastPageViewed");
      if (targetPage === undefined || targetPage === "" || (psa_params.data.modeXSL === false && targetPage === pap.K_internalPageLocalisation)) {
        targetPage = pap.defaultpage;
      }
    }
  }

  if (targetPage === "scan.html") {
    gvtController.runScan();
  } else {
    this.loadPage(targetPage)
  }
}

pap.getIdEcranFromCurrentURL = function() {
  return pap.getIdEcranFromURL(URI(window.location.href))
}

pap.getIdEcranFromURL = function(url) {
    return URI(url).query(true).idEcran
}

pap.popstateHistory = function(event) {
  if ( !pap.dontPopState ) {
    pap.loadPageNoHistory(pap.getIdEcranFromCurrentURL(), false)
  }
}

pap.loadPageChangeHash = function (urlPage, forceHash = false) {
  pap.dontPopState = true
  historique.addPage(urlPage)
  pap.loadPageNoHistory(urlPage, false);
  pap.dontPopState = false

  if (forceHash) {
    pap.forceReloadUrlHash()
  }
}

pap.cleanHash = function(hashPage) {
  if ( hashPage == null ) {
    return
  }

  const dataUrlPage = hashPage.split("#");
  return dataUrlPage[0]
}

pap.loadPage = function (urlPage) {
  urlPage = pap.cleanHash(urlPage)
  if (urlPage == null) {
    return
  }

  if (urlPage === "") {
    navigationWeb.index = 0;
    urlPage = navigationWeb.listSummary[navigationWeb.index];
  }

  ProgressIndicator.show();
  if (psa_params.data.isDoc === undefined) {
    drawerNavigation.init();
    gvtController.stopScan();
  }

  pap.loadPageNoHistory(urlPage, true)
}

pap.loadPageNoHistory = function (urlPage, handleHistory) {
  ProgressIndicator.show();
  if (typeof popover !== "undefined") popover.hide();

  if (urlPage === "") {
    urlPage = pap.defaultpage;
  }

  pap.currentPage = urlPage;

  if (pap.currentPage !== undefined && pap.currentPage !== "") {
    if (psa_params.data.modeXSL === true) {
      switch (pap.currentPage) {
        case pap.K_internalPageLocalisation :
          pap.loadPageDoneXSL(loadDDB.getHTMLlocalisation(), {
            handleHistory: handleHistory,
            urlHistory: pap.currentPage
          })
          break;

        case pap.K_internalPageLights :
          pap.loadPageDoneXSL(loadDDB.getHTMLlightsList(), {
            handleHistory: handleHistory,
            urlHistory: pap.currentPage
          })
          break;

        case pap.K_internalPageEquipments :
          pap.loadPageDoneXSL(loadDDB.getHTMLequipmentsList(), {
            handleHistory: handleHistory,
            urlHistory: pap.currentPage
          })
          break;

        case pap.K_internalPageAudionav :
          pap.loadPageDoneXSL(loadDDB.getHTMLaudionavList(), {
            handleHistory: handleHistory,
            urlHistory: pap.currentPage
          })
          break;

        case pap.K_internalPageIndexAlpha :
          pap.loadPageDoneXSL(loadDDB.getHTMLindexAlpha(), {
            handleHistory: handleHistory,
            urlHistory: pap.currentPage
          })
          break;

        default :
          loadDDB.getHTMLTopicByID(pap.currentPage, pap.loadPageDoneXSL, {
            handleHistory: handleHistory,
            urlHistory: pap.currentPage
          })
      }
    } else {
      loadContent.loadContentDoc(pap.currentPage, pap.loadPageDone, pap.loadPageError, handleHistory)
    }
  }
}

pap.loadPageError = function(jqXHR, textStatus, errorThrown) {
  console.log("loadPageError textStatus: ", textStatus);
  console.log("loadPageError errorThrown: ", errorThrown);
  historique.erreurChargement();
  ProgressIndicator.hide();

  if ( psa_params.data.isDoc === undefined ) {
    notification.errorOpenConsultation(function(){});
  }
}

pap.loadPageDoneCommon = function (fragment, localParameters) {
  let $newContent = $("<div/>").attr('id', 'content');
  $newContent.append($(fragment));
  $($newContent).attr("data-role", "content");

  if (typeof popover !== "undefined") popover.destroyAll();

  if (localParameters && localParameters.handleHistory) {
    historique.addPage(localParameters.urlHistory);
    historique.idFunctionGroup = "";

    preferences.setItemVehicle("lastPageViewed", localParameters.urlHistory);
  }

  const key = navigationWeb.mapSummaryUrlKey[pap.currentPage]
  navigationWeb.activateItemSummaryFromId(key)

  loadDDB.displayChangedTopics($newContent);

  const langLanguageData = ddbViewerParams.data.lang_iso.split("_");
  rtlDirection.languageDocContent($newContent, langLanguageData[0]);

  relatedLink.load($newContent);
  indexAlpha.loadHref($newContent);
  
  $newContent.find("[data-i18n]").i18n();

  pap.pageContentLoaded($newContent)
}

pap.loadPageDone = function(data, textStatus, jqXHR) {
  pap.loadPageDoneCommon(loadContent.transformContent(data), this.papParameters);
}

pap.loadPageDoneXSL = function(data, localParameters) {
  pap.loadPageDoneCommon(data, localParameters)
}

pap.pageContentLoaded = function (htmlText) {
  if (typeof animations !== "undefined") {
    animations.stop($('[id="oldcontent"]'));
  }

  $('[id="oldcontent"]').remove();
  $("#content").attr('id', 'oldcontent');

  if (typeof animations !== "undefined") {
    animations.stop($('[id="oldcontent"]'));
  }

  $('[id="content"]').remove();
  $("#oldcontent").remove();
  $("[data-fragment='doc']").append($(htmlText));

  window.postMessage({event: "ecrancharge.pap"}, "*");
}

pap.ecranEstCharge = function (event) {

  if (event.data.event === "ecrancharge.pap") {
    const $newContent = $("#content");

    carrousel.init($newContent);
    popover.init($newContent);
    pleinEcran.initEcran();
    function_group.init($newContent);

    footerController.loadFooterApp();
    headerController.loadHeaderDoc($newContent);
    scrollController.createScroll();

    pap.retinaLoadInContext($newContent)
    pap.transitionPagesEnd();

    $newContent.find("a").on('click', function (event) {
      event.preventDefault();

      const href = event.currentTarget.href;
      const dataHref = href.split("#");
      navigationWeb.activateItemSummaryFromUrl(dataHref[dataHref.length - 1] + ".dita");
      pap.loadPageChangeHash(dataHref[dataHref.length - 1])
    });
  }

  if ($('[data-type-screen="indexAlphabetique"]').length > 0) {
    pap.getIndexAlphaSizeLayout();
  }
}

pap.getIndexAlphaSizeLayout = function(){
   var indexAlphaHeight = $('[data-type-screen="indexAlphabetique"]').parents('[data-role="content"]').innerHeight();
   var summaryHeight = $(".indexAlphaSummary").innerHeight();

    $(".indexAlphaContent").height(indexAlphaHeight - summaryHeight);
}

pap.transitionPagesStart = function() {
  if ( pap.doAnimate ) {
    $('[id="content"]').fadeIn(pap.transitionSpeed, function() {pap.transitionPagesMiddle()});
  } else {
    $('[id="content"]').show(0, function() {pap.transitionPagesMiddle()});
  }
}

pap.transitionPagesMiddle = function() {
  if ( pap.doAnimate ) {
    $('[id="oldcontent"]').fadeOut(pap.transitionSpeed, function() {pap.transitionPagesEnd()});
  } else {
    $('[id="oldcontent"]').hide(0, function() {pap.transitionPagesEnd()});
  }
  pap.retinaLoadInContext($("#content"));
}

pap.transitionPagesEnd = function() {
  $('[id="oldcontent"]').remove();
  $('[id="content"]').show();

  if ( typeof animations !== "undefined" ) animations.init($('[id="content"]'));
  footerController.loadFooterApp();
  footerController.selectItem();
  setTimeout(pap.restorePageState, 150);

  if ( typeof sendCategories !== "undefined" ) sendCategories();
  if ( typeof createKnobNavigation !== "undefined" ) createKnobNavigation();
  if ( typeof bindTouchEvents !== "undefined" ) bindTouchEvents();
  ProgressIndicator.hide();
  $('[data-title]').attr('data-title');

  tagManagerController.tagGoogleAnalytics();
}

pap.retinaLoadInContext = function ($context) {
  if (!$context) $context = $("#content");

  if (Retina.isRetina()) {
    var images = $('img:visible', $context);
    new pap.retinaLoadManager(images);
  }
}

pap.retinaLoadManager = function(images) {
  var retinaImages = [];
  
  function init() {
    for (var i = 0; i < images.length; i += 1) {
      var image = images[i];
      if (!!!image.getAttributeNode('data-no-retina')) {
        retinaImages.push(new RetinaImage(image));
      }
    }
  }

  init();
}

pap.restorePageState = function () {

  const idEcran = URI().query(true).idEcran
  if (idEcran !== undefined) {
    let href = loadDDB.flatListByID[idEcran].file
    const relatedLinkHref = localStorage.getItem("relatedLinkHref")

    if (relatedLinkHref !== undefined && href !== relatedLinkHref) {
      href = relatedLinkHref
    }

    const targetElt = $("[data-topichref='" + href + "']")
    const targetEltTopicHref = targetElt.data("topichref")
    const firstChild = targetElt.parent().children().first()
    const firstChildTopicHref = firstChild.data("topichref")

    if (targetElt.length > 0 && targetEltTopicHref !== firstChildTopicHref) {
      scrollController.scrollToWithAnimate(targetElt)
      localStorage.removeItem("relatedLinkHref")

    } else {
      scrollContentDefault()
    }
  } else {
    scrollContentDefault()
  }

  function scrollContentDefault() {
    const scrollParam = parseInt(URI().query(true).scroll) || 0;
    const orientationParam = URI().query(true).orientation || historique.orientation.landscape
    const relatedLinksStates = (URI().query(true).links || "").split(",")
    scrollController.scrollTop(scrollParam, orientationParam, relatedLinksStates)
  }
}

pap.rechargerEcran = function() {
  pap.loadPageNoHistory(pap.getIdEcranFromCurrentURL, false);
}

pap.forceReloadUrlHash = function () {
  const idEcran = pap.getIdEcranFromCurrentURL()
  if ( pap.hashchangeEnabled === true && pap.currentPage !== idEcran && idEcran !== "dummy.html" && idEcran !== "indexAlpha" && idEcran !== "relatedLink" ) {
    var fragmentPage = $("body").attr("data-fragment");

    if ( fragmentPage === "doc" ) {
      tagManagerController.tagGoogleAnalyticsAction({"eventCategory": "Content", "eventAction": "Redirection::Internal",
        "eventLabel": ""});
    }

    pap.loadPage(idEcran);
  }
}

pap.goToLocalisation = function() {
  if ( pleinEcran.etat !== pleinEcran.etatpleinecran ) {
    var fragmentPage = $("body").attr("data-fragment");
    var $content = $("#content");

    if ( fragmentPage === "doc" ) {
      var typeScreen = $($content).find("[data-type-screen]").attr("data-type-screen");

      if ( typeScreen === tagManagerController.typeScreen.temoins ) {
        tagManagerController.tagGoogleAnalyticsAction({"eventCategory": "Content", "eventAction": "Redirection::Internal",
        "eventLabel": "Recherche visuelle"});
      }
    }
    else {
      tagManagerController.tagGoogleAnalyticsAction({"eventCategory": "Footer", "eventAction": "Redirection::Internal",
      "eventLabel": "Recherche visuelle"});
    }

    pap.resolveTarget(pap.K_internalPageLocalisation, "localisation/index.html");
  }
}

pap.goToTemoins = function() {
  if ( pleinEcran.etat !== pleinEcran.etatpleinecran ) {
    tagManagerController.tagGoogleAnalyticsAction({"eventCategory": "Footer", "eventAction": "Redirection::Internal",
    "eventLabel": "Témoins"});

    pap.resolveTarget(pap.K_internalPageLights, "temoins/index.html");
  }
}

pap.resolveTarget = function(targetXSL, targetNoXSL) {
  var targetPage = pap.targetMode(targetXSL, targetNoXSL);
  pap.loadPage(targetPage);

  if ( psa_params.data.isDoc === true ) {
    pap.loadPageChangeHash(targetPage, true);
  }
  else {
    pap.loadPageChangeHash("dummy.html", true);
  }
}

pap.targetMode = function(targetXSL, targetNoXSL) {
  if ( psa_params.data.modeXSL === true ) {
    return targetXSL;
  }
  else {
    return targetNoXSL;
  }
}
